import { render, staticRenderFns } from "./PaymentSources.vue?vue&type=template&id=0fd1ab27&"
import script from "./PaymentSources.vue?vue&type=script&lang=js&"
export * from "./PaymentSources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports